import React, { useRef, useEffect } from "react";
import { Bold, Italic, Underline, List, ListOrdered, Link2, Heading } from "lucide-react";

const Btn = ({ onClick, children, title }) => (
  <button type="button" title={title} onMouseDown={(e) => { e.preventDefault(); onClick(); }}
    className="w-8 h-8 rounded-md flex items-center justify-center text-[#4A5550] hover:bg-[#F0EFEB] hover:text-[#2C3531] transition-colors">
    {children}
  </button>
);

export default function RichTextEditor({ value, onChange, testid = "rte" }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) ref.current.innerHTML = value || "";
  }, [value]);
  const cmd = (c, arg = null) => { document.execCommand(c, false, arg); emit(); ref.current?.focus(); };
  const emit = () => onChange(ref.current?.innerHTML || "");
  const link = () => { const url = window.prompt("Link URL"); if (url) cmd("createLink", url); };

  return (
    <div className="border border-[#E8E6E1] rounded-xl overflow-hidden bg-white" data-testid={testid}>
      <div className="flex items-center gap-0.5 px-2 py-1.5 border-b border-[#F0EFEB] bg-[#FDFBF7]">
        <Btn title="Heading" onClick={() => cmd("formatBlock", "<h2>")}><Heading className="w-4 h-4" /></Btn>
        <Btn title="Bold" onClick={() => cmd("bold")}><Bold className="w-4 h-4" /></Btn>
        <Btn title="Italic" onClick={() => cmd("italic")}><Italic className="w-4 h-4" /></Btn>
        <Btn title="Underline" onClick={() => cmd("underline")}><Underline className="w-4 h-4" /></Btn>
        <span className="w-px h-5 bg-[#E8E6E1] mx-1" />
        <Btn title="Bullet list" onClick={() => cmd("insertUnorderedList")}><List className="w-4 h-4" /></Btn>
        <Btn title="Numbered list" onClick={() => cmd("insertOrderedList")}><ListOrdered className="w-4 h-4" /></Btn>
        <Btn title="Link" onClick={link}><Link2 className="w-4 h-4" /></Btn>
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning onInput={emit} data-testid={`${testid}-area`}
        className="rte-content min-h-[120px] px-4 py-3 text-sm text-[#2C3531] focus:outline-none" />
    </div>
  );
}
